import { Dialog } from '@material-ui/core';
import React from 'react';
import TickIcon from "assets/img/svg/svgComponents/TickIcon";
import AButton from '../../../../common/form-fields-mui/AButton';

const ApprovalSentSuccessDialog = ({
    open,
    setOpen,
    heading,
    subHeading,
    closeCb = () => { },
    buttonLabel = "Okay",
    buttonStyle = { width: "25%" },
    disableScrollLock = false
}) => {
    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="xs"
            disableScrollLock={disableScrollLock}
        >
            <div className='approval-sent-dialog'>
                <span className='d-flex justify-content-center align-items-center tick-icon'><TickIcon /></span>
                <div className='header'>{heading}</div>
                <div className='subHeader'>{subHeading}</div>
                <AButton
                    variant='primary_filled'
                    onClick={() => { setOpen(false); closeCb() }}
                    className='no-ml-btn '
                    updatedStyle={buttonStyle}
                >
                    {buttonLabel}
                </AButton>
            </div>

        </Dialog>
    );
}

export default ApprovalSentSuccessDialog;